import React from 'react';
import PropTypes from 'prop-types';



const EditFormFieldTable = ({ fields }) => {   
    return (
        <div className="table-wrap">
            <table className="table advanced hover">
                <colgroup>
                    <col />
                    <col />
                </colgroup>
                <tbody>
                {fields.map((item, index) => {                                    
                    return (<tr key={index}>
                        {
                            typeof item.title === 'function' ? 
                                <th className="text-left no-padding">
                                    <div className="form">
                                        {item.title()}
                                    </div>
                                </th>
                            :
                                <th className="text-left">{item.title}</th>
                        }
                        <td className="no-padding">
                            <div className="form">
                                {typeof item.edit === 'function' ? (item.edit()) : (item.edit)}                                      
                            </div>
                        </td>
                    </tr>);
                })}          
                </tbody>
            </table>
        </div>    
      );
};

EditFormFieldTable.propTypes = {    
    fields : PropTypes.array
};

export default EditFormFieldTable;